import { render, staticRenderFns } from "./JSONPretty.vue?vue&type=template&id=9db9fa78&scoped=true&"
import script from "./JSONPretty.vue?vue&type=script&lang=js&"
export * from "./JSONPretty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db9fa78",
  null
  
)

export default component.exports